import React from 'react';
import { motion } from 'framer-motion';
import { Rocket } from 'lucide-react';
export function CtaBand() {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative z-10 py-24 px-6" data-id="element-25">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.8
    }} className="relative max-w-6xl mx-auto rounded-[2.5rem] overflow-hidden border border-white/10 p-12 md:p-20 text-center" style={{
      background: 'radial-gradient(120% 140% at 0% 0%, rgba(30,58,138,0.55) 0%, transparent 55%), radial-gradient(120% 140% at 100% 100%, rgba(109,40,217,0.55) 0%, transparent 55%), radial-gradient(90% 120% at 50% 50%, rgba(6,182,212,0.25) 0%, #06070f 70%)'
    }} data-id="element-26">
        {/* animated gradient line on top */}
        <div className="absolute top-0 left-0 right-0 h-[2px] animate-nebula-line bg-gradient-to-r from-transparent via-cyan-400 to-transparent" data-id="element-27" />

        {/* soft drifting glow blobs */}
        <div className="pointer-events-none absolute -top-24 right-1/4 w-72 h-72 rounded-full bg-cyan-500/20 blur-3xl" data-id="element-28" />
        <div className="pointer-events-none absolute -bottom-24 left-1/4 w-72 h-72 rounded-full bg-violet-500/20 blur-3xl" data-id="element-29" />

        <div className="relative z-10 flex flex-col items-center" data-id="element-30">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/15 bg-white/5 backdrop-blur-md text-xs tracking-widest text-cyan-300 mb-6 uppercase" data-id="element-31">
            <Rocket className="w-4 h-4" data-id="element-32" />
            הצטרפו למסע
          </span>
          <h2 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60 drop-shadow-[0_0_30px_rgba(255,255,255,0.25)] mb-6 leading-tight" data-id="element-33">
            מוכנים לכבוש את החלל?
          </h2>
          <p className="text-gray-300 text-lg md:text-xl max-w-2xl mb-10 font-light" data-id="element-34">
            בין אם אתם משקיעים, מהנדסים או חולמים — מקומכם איתנו בקו ההזנקה אל
            מעבר לאטמוספירה.
          </p>
          <button onClick={scrollToContact} className="group relative px-10 py-4 rounded-full bg-white text-black font-bold text-lg overflow-hidden shadow-[0_0_40px_rgba(6,182,212,0.45)] hover:shadow-[0_0_60px_rgba(109,40,217,0.6)] transition-shadow" data-id="element-35">
            <span className="relative z-10" data-id="element-36">שריינו את מקומכם</span>
            <span className="absolute inset-0 bg-gradient-to-r from-cyan-300 to-violet-300 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-37" />
          </button>
        </div>
      </motion.div>
    </section>;
}